import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicCheckbox, Loader } from 'core/components';
import _ from 'lodash';

function PickingModeCarrierTypesTemplate({
	pickingModeCarrierTypesViewStore: {
		loading,
		carrierTypes,
		modalParams,
		onCheck,
		submit,
		onSelectAllCheck,
		isSelectAllChecked,
	},
	t,
}) {
	if (loading) return <Loader />;
	return (
		<section>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('PICKINGMODECARRIERTYPES.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<div className="card card--med spc--bottom--sml">
					{t('PICKINGMODECARRIERTYPES.NOTE')} <span className="type--color--warning">*</span>
				</div>

				<div className="card card--med spc--bottom--sml">
					<div className="spc--bottom--sml">
						<BaasicCheckbox
							checked={isSelectAllChecked}
							onChangeCallback={onSelectAllCheck}
							id={'select-all'}
							className={'input--check'}
							label={t('PICKINGMODECARRIERTYPES.SELECTALL')}
						/>
					</div>

					<div className="separator--primary spc--bottom--sml"></div>

					{_.map(carrierTypes, item => {
						return (
							<div key={item.id}>
								<BaasicCheckbox
									checked={item.isChecked}
									onChangeCallback={() => onCheck(item)}
									id={item.id}
									className={'input--check'}
									label={item.name}
								/>
							</div>
						);
					})}
				</div>
			</div>
			<div className="ReactModal__footer">
				<button
					disabled={!carrierTypes.some(ct => ct.isChecked)}
					className="btn btn--med btn--primary spc--right--tny spc--bottom--sml"
					type="button"
					onClick={submit}
				>
					{t('APPLY')}
				</button>
			</div>
		</section>
	);
}

export default defaultTemplate(PickingModeCarrierTypesTemplate);
